// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_YGE","cls2":"Comments-cls2__03 Comments-cls1_YGE"};